import { lazy } from 'react';

const DriverDispatchLinkConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {
        navbar: { display: false },
        toolbar: { display: false },
        footer: { display: false },
        mode: 'fullwidth',
      },
    },
  },
  routes: [
    {
      path: '/driver/dispatch',
      component: lazy(() => import('./DriverDispatchLinkPage')),
    },
  ],
};

export default DriverDispatchLinkConfig;
